
<template>
  <div class="footer_bottom">
    <div class="footer_center">
      <!-- <div class="subFooterContent"> -->
      <!-- <p>
        Copyright © 2000 - 2020 　All Rights Reserve 版权所有 经济日报社 &nbsp;&nbsp;
        <a style="color:#fff;"
           target="_blank"
           href="http://beian.miit.gov.cn/">京ICP备15055676号-1 </a>
        <br> 联系电话：18910257336（微信同号）010-58392313
      </p> -->
      <!-- 修改备案号 by tq time 20211027 -->
      <div>
        <p>Copyright © 2000 - {{$fun.getDate()}} 　All Rights Reserve 版权所有 经济日报社</p>
        <!-- <p>联系电话：18910257336（微信同号）010-58392313</p> -->
        <p>联系电话：15300311126 010-58392313</p>
        <div style="width:300px;margin:0 auto; padding:20px 0;">
		 		  <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202009786" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="@/assets/image/common/keep_record.png" style="float:left;"/>
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备 11010202009786号</p>
          </a>
		 	  </div>
      </div>
      <!--联系邮箱：jjrbzjsj@163.com-->
      <!-- <div class="subFooterImg">
        <img src="@/assets/image/footer/ewm.png"
             class="">
        <p>中经视觉客服微信</p>
      </div> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script >
// import request from 'utils/request'
import { record_save } from '@/utils/api/activity.js'

export default {
  name: 'ft',
  props: {
    msg: String
  },
  data () {
    return {


    };
  },
  computed: {},
  watch: {},
  methods: {
    // 访问量
    look_data () {
      record_save().then((res) => {
        let data = res.data;
        // console.log(data);
      })
    },
  },
  created () {
    this.look_data();//浏览量

  },
  mounted () { },
};
</script>


<style scoped>
.footer_bottom {
  background: url(https://v.jingjiribao.cn/image/footer-bg.jpg) no-repeat;
  background-size: 100%;
  width: 100%;
}

.footer_center {
  width: 12.45rem;
  /* height: 1.8rem; */
  /* height: 100%; */
  position: relative;
  /* padding: 0.6rem 0px 0.5rem; */
  padding: 60px 0px 50px;
  text-align: center;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer_center p {
  color: #fff;
  line-height: 0.35rem;
  line-height: 30px;
  margin: 0;
  font-size: 0.16rem;
}
.footer_center>div:first-child {
  flex: 1;
}

.subFooterImg {
  /* float: right;
  padding-top: 0.1rem;
  position: absolute;

  right: 0;
  top: 0;
  box-sizing: border-box; */
}

.subFooterImg img {
  width: 1rem;
}
/* pc端 */
/*当屏幕尺寸大于749px时，应用下面的CSS样式*/
.footer_center {
  /* border: 1px solid orange; */
}

/* 移动端  */
/*当屏幕尺寸小于749px时，应用下面的CSS样式*/
/* .footer_center {
  width: 100%;
} */

/* 隐藏 pc的导航 搜索和投稿 头像*/
.mobile {
  display: none;
}
@media screen and (max-width: 650px) {
  .footer_bottom {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue